/**
 * Microsoft Clarity analytics integration
 *
 * This module initializes Microsoft Clarity for tracking user behavior,
 * session recordings, and heatmaps.
 */

export const initClarity = () => {
  const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

  // Don't initialize if project ID is missing
  if (!clarityProjectId) {
    console.warn('Microsoft Clarity Project ID not provided. Analytics tracking will be disabled.');
    return;
  }

  // Add Clarity tracking script
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments) };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", clarityProjectId);

  console.log('Microsoft Clarity analytics initialized successfully.');
};

/**
 * Handle user consent for Clarity tracking.
 * This function should be called after the user has given their consent.
 */
export const handleClarityConsent = () => {
  if (window.clarity && typeof window.clarity === 'function') {
    window.clarity('consentv2', {
      ad_Storage: "granted",
      analytics_Storage: "granted"
    });
    console.log('Clarity consent granted.');
  }
  // Initialize Clarity after consent has been given
  initClarity();
};

/**
 * Track custom events in Clarity
 * @param {string} eventName - Name of the event to track
 * @param {Object} [eventData] - Optional data to associate with the event
 */
export const trackClarityEvent = (eventName, eventData = {}) => {
  if (window.clarity && typeof window.clarity === 'function') {
    window.clarity("set", eventName, eventData);
    console.log(`Clarity event tracked: ${eventName}`);
  }
};

export default initClarity;